import { http } from "../http/Http";
import { DoneScreenHeaderField } from "../models/DoneScreenHeaderField";
import { ServiceResponse } from "../models/ServiceResponse";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";

export class DoneScreenHeaderFieldService {

    getDoneScreenHeaderFieldsByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<DoneScreenHeaderField[]>> => {
        const { data } = await http.post<ServiceResponse<DoneScreenHeaderField[]>>("DoneScreenHeaderField/GetByFilters", apiQueryFilter);
        return data;
    };
}